<template>
  <div id="app">
    <transition name="slide" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: "App"
}
</script>

<style>
/* App.vue 全局样式 — 从 PUBLISH 线上 app.css 反查还原 */
::-webkit-scrollbar { display: none; }

.slide-enter-active,
.slide-leave-active { transition: all .2s; }
.slide-enter,
.slide-leave-to { opacity: 0; transform: translateY(-100px); }

.page-title { color: #000; font-size: 36px; font-weight: 700; }
.page-sub-title {
  margin-top: 15px; margin-bottom: 30px;
  font-size: 18px; font-weight: 500; color: #5f5f5f;
}
.frozen-amount {
  display: flex; flex-direction: row; align-items: center;
  font-size: 12px; color: grey;
}
.tools-container {
  z-index: 1000; position: fixed; height: 60px;
  left: 0; right: 0; bottom: 0;
  background-color: rgba(83, 86, 93, 0.5333333333333333);
  display: flex; flex-direction: row-reverse; align-items: center;
  padding-right: 100px;
}
.back-button {
  position: absolute; left: 60px; top: 30px; width: 100px !important;
}

/* 全局 view-design 组件覆盖 */
.ivu-drawer {
  position: fixed !important; top: 25px !important; right: 15px !important;
  width: 470px !important;
}
.ivu-drawer-content {
  height: calc(100% - 50px) !important;
  border-radius: 20px !important;
  overflow: hidden !important;
}
.ivu-drawer-body {
  display: flex; padding: 0 !important; overflow: hidden !important;
}
.ivu-upload-drag { height: 100%; width: 100%; }
.ivu-table th { color: #fff; }
.ivu-modal-body { padding: 0 !important; }
.ivu-modal-content { overflow: hidden; }
.ivu-checkbox-wrapper { padding-top: 4px; }
</style>
